<template>
  <div class="home v2">
    <div class="content" ref="homeContent">
        <section class="d-flex flex-grow-1" v-if="version == 2">
          <b-container fluid class="d-flex flex-column">
            <b-row class="flex-grow-1">
              <b-col class="info px-0">
                <b-row class="page-header m-md-0 pt-3 text-center text-lg-left">
                  <b-col lg="auto" class="d-flex align-items-center">
                    <img :src="logo" width="100" class="mb-3" :alt="name">
                  </b-col>
                  <b-col cols="12" lg="6" class="d-flex flex-column justify-content-center mb-3">
                    <h1 class="mb-0">{{ name }}</h1>
                    <h4 class="font-lighter mb-0">{{ (agenda != null)?agenda.name:'' }}</h4>
                  </b-col>
                  <b-col class="d-flex flex-column justify-content-center mb-3 text-lg-right">
                    <p class="mb-1" v-if="telephone != null && telephone != ''">
                      <span><i class="fal fa-phone mr-2"></i> {{ telephone }}</span>
                    </p>
                    <p class="mb-1" v-if="cellphone != null && cellphone != ''">
                      <a v-if="cellphone != null && cellphone != ''" target="_blank" :href="'https://wa.me/55'+cellphone.replace(/\D/g, '')"><i class="fab fa-whatsapp mr-2"></i> {{ cellphone }}</a>
                    </p>
                    <p class="mb-0"><i class="fal fa-map-marker-alt mr-2"></i> <span v-html="buildAddress(true)"></span></p>
                  </b-col>
                </b-row>

                <b-row class="mt-4">
                  <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                    <b-row>
                      <template v-if="actualStep === 1">
                        <b-col cols="12">
                          <h2 class="section-title mb-3">Selecione um horário</h2>
                        </b-col>
                        <b-col cols="12" class="mb-3" v-if="agenda && agenda.appointments.length === 0">
                          <p class="text-center m-3">
                            No momento não há horários disponíveis para agendamento.
                          </p>
                        </b-col>
                        <b-col cols="12" class="calendar mb-3" v-else-if="!showWeek && day != null && schedules != null">
                          <div class="header text-center">
                            <b-row class="align-items-center justify-content-between">
                              <b-col sm="auto" class="w-auto" :class="{ 'disabled': day == firstDay, 'pointer': day != firstDay }" @click="decreaseDate()"><i class="fal fa-2x fa-chevron-left ml-1"></i></b-col>
                              <b-col>
                                <span class="font-lighter">{{ moment(day).format('dddd') }}</span><br/>{{ moment(day).format('DD/MM') }}
                              </b-col>
                              <b-col sm="auto" class="w-auto" :class="{ 'disabled': day == lastDay, 'pointer': day != lastDay }" @click="increaseDate()"><i class="fal fa-2x fa-chevron-right mr-1"></i></b-col>
                            </b-row>
                          </div>
                          <div class="content">
                            <ul class="times row" v-if="schedules.length > 0">
                              <li v-for="(time, key) in schedules" class="pointer" @click="selectTime(time)" :class="{'selected': appointmentForm.start_datetime == time}">{{ moment(time).format('HH:mm') }}</li>
                            </ul>
                            <p class="text-center m-3" v-if="schedules.length == 0">
                              Não há horário disponível para esta data.
                            </p>
                          </div>
                          <b-button class="mt-3" v-if="appointmentForm.start_datetime != null" @click="goToNextStep" block>Próxima etapa <i class="fal fa-chevron-right"></i></b-button>
                        </b-col>
                        <b-col cols="12" class="calendar mb-3" v-else-if="showWeek && day != null && schedules != null">
                          <div class="header text-center">
                            <b-row class="align-items-center justify-content-between">
                              <b-col sm="auto" class="w-auto" :class="{ 'disabled': day == firstDay, 'pointer': day != firstDay }" @click="decreaseDate()"><i class="fal fa-2x fa-chevron-left ml-1"></i></b-col>
                              <b-col>
                                <span class="font-lighter">{{ moment(day).format('ddd') }}</span><br/>{{ moment(day).format('DD/MM') }}
                              </b-col>
                              <b-col sm="auto" class="w-auto" :class="{ 'disabled': day == lastDay, 'pointer': day != lastDay }" @click="increaseDate()"><i class="fal fa-2x fa-chevron-right mr-1"></i></b-col>
                            </b-row>
                          </div>
                          <div class="content">
                            <ul class="times row" v-if="schedules.length > 0">
                              <li v-for="(time, key) in schedules" class="pointer" @click="selectTime(time)" :class="{'selected': appointmentForm.start_datetime == time}">{{ moment(time).format('HH:mm') }}</li>
                            </ul>
                            <p class="text-center m-3" v-if="schedules.length == 0">
                              Não há horário disponível para esta data.
                            </p>
                          </div>
                          <b-button class="mt-3" v-if="appointmentForm.start_datetime != null" @click="goToNextStep" block>Próxima etapa <i class="fal fa-chevron-right"></i></b-button>
                        </b-col>
                      </template>
                      <b-col cols="12" class="mb-3" v-else-if="actualStep > 1">
                        <h4 class="selected-time mb-3"><i class="fal fa-calendar-check mr-2"></i><span class="font-lighter">Data selecionada:</span> {{ moment(appointmentForm.start_datetime).format('dddd[,] DD/MM [às] HH:mm')}}</h4>
                        <h2 class="section-title mb-3">Informe os dados do paciente</h2>
<!--                        <div class="box-cj">-->
<!--                          <div class="content">-->
                            <validation-observer ref="appointmentForm" v-slot="{ invalid }">
                              <b-row>
                                <b-col cols="12">
                                  <div class="form-group">
                                    <label class="cj-label">Nome</label>
                                    <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                                      <input v-model="appointmentForm.name" type="text" class="form-control" :class="{ 'error': errors.length > 0 }">
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>

                                <b-col cols="12">
                                  <div class="form-group">
                                    <label class="cj-label">E-mail{{requiredFields.indexOf('email') >= 0 ? '' : ' (opcional)'}}</label>
                                    <validation-provider name="e-mail" :rules="{ required: requiredFields.indexOf('email') >= 0, email: true }" v-slot="{ errors }">
                                      <input v-model="appointmentForm.email" type="email" class="form-control" :class="{ 'error': errors.length > 0 }">
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>

                                <b-col cols="6">
                                  <div class="form-group">
                                    <label class="cj-label">CPF</label>
                                    <validation-provider name="CPF" :rules="{ required: true, cpf: true }" v-slot="{ errors }">
                                      <input v-model="appointmentForm.document" type="tel" class="form-control" v-mask="'###.###.###-##'" :class="{ 'error': errors.length > 0 }">
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>
                                <b-col cols="6">
                                  <div class="form-group">
                                    <label class="cj-label">Dt. Nasc.{{requiredFields.indexOf('birthday') >= 0 ? '' : ' (opcional)'}}</label>
                                    <validation-provider name="data de nascimento" :rules="{ required: requiredFields.indexOf('birthday') >= 0 }" v-slot="{ errors }">
                                      <input v-model="appointmentForm.birthday" type="tel" class="form-control" v-mask="'##/##/####'" :class="{ 'error': errors.length > 0 }">
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>

                                <b-col cols="6">
                                  <div class="form-group">
                                    <label class="cj-label">Celular{{requiredFields.indexOf('cellphone') >= 0 ? '' : ' (opcional)'}}</label>
                                    <validation-provider name="celular" :rules="{ required: requiredFields.indexOf('cellphone') >= 0 }" v-slot="{ errors }">
                                      <input v-model="appointmentForm.cellphone" class="form-control" v-mask="'(##) #####-####'" :class="{ 'error': errors.length > 0 }">
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>
                                <b-col cols="6" v-if="sap">
                                  <div class="form-group">
                                    <label class="cj-label">Já é paciente?</label>
                                    <validation-provider name="já é paciente?" :rules="{ required: true }" v-slot="{ errors }">
                                      <multiselect v-model="appointmentForm.alreadyPatient" :options="alreadyPatient" track-by="name" label="name" :preselect-first="true" :searchable="false" :allowEmpty="false" :show-labels="false" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>

                                <b-col cols="6">
                                  <div class="form-group">
                                    <label class="cj-label">Plano de saúde</label>
                                    <validation-provider name="plano de saúde" :rules="{ required: true }" v-slot="{ errors }">
                                      <multiselect v-model="appointmentForm.health_plan" :options="healthPlans" @input="healthPlanChanged" track-by="name" label="name" :searchable="true" :allowEmpty="false" :show-labels="false" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>
                                <b-col cols="6">
                                  <div class="form-group">
                                    <label class="cj-label">Formato de atendimento</label>
                                    <validation-provider name="formato de atendimento" :rules="{ required: true }" v-slot="{ errors }">
                                      <multiselect v-model="appointmentForm.appointmentFormat" :options="appointmentFormats" @input="appointmentFormatChanged" track-by="name" label="name" :preselect-first="true" :searchable="false" :allowEmpty="false" :show-labels="false" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                  </div>
                                </b-col>

                                <b-col cols="12" v-if="!canPerformAction">
                                  <p class="bg-info text-white text-center p-3">Estamos realizando o seu agendamento, aguarde....</p>
                                </b-col>

                                <b-col cols="12">
                                  <b-row>
                                    <b-col>
                                      <b-button @click="actualStep -= 1" block><i class="fal fa-chevron-left"></i> Voltar etapa</b-button>
                                    </b-col>
                                    <b-col>
                                      <b-button block @click="makeAppointment" variant="primary" :disabled="!canPerformAction">{{makeAppointmentText}}</b-button>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </validation-observer>
<!--                          </div>-->
<!--                        </div>-->
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </section>
        <div class="align-self-baseline text-center w-100 mt-3">
          <p class="credits text-center mb-4"><img src="@/assets/images/consulta-ja-logo2.png" height="20px" alt=""> Desenvolvido por <a href="https://consultaja.com" target="_blank">Consultaja.com</a></p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      isLoading: null,

      version: 0,
      sap: true,
      showWeek: false,
      requiredFields: [],

      firstDay: null,
      lastDay: null,
      dayIndex: 0,

      firstWeek: null,
      lastWeek: null,

      logo: require('@/assets/images/avatar.svg'),
      name: null,
      description: null,
      cellphone: null,
      telephone: null,
      email: null,
      healthPlans: [],
      address: null,
      agenda: null,

      day: null,
      week: null,
      schedules: null,
      actualStep: 1,

      canPerformAction: true,

      appointmentForm: {
        start_datetime: null,
        name: null,
        email: null,
        document: null,
        birthday: null,
        cellphone: null,
        alreadyPatient: null,
        appointmentFormat: null,
        health_plan: null
      },
      alreadyPatient: [
        { value: false, name: 'Não' },
        { value: true, name: 'Sim' }
      ],
      appointmentFormats: [],
      healthPlanAppointmentFormats: [],
      paidAppointmentFormats: [],
      makeAppointmentText: 'Agendar'
    }
  },
  mounted() {
    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null)
          this.isLoading.hide();
      }
    });
    this.getAgenda();
  },
  methods: {
    getAgenda() {
      this.eventBus.$emit('IS_LOADING', true);
      this.api.getAgenda(this.$route.params.id).then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        let agendaData = res.data;

        this.version = agendaData.version;
        this.sap = agendaData.sap;
        if(this.sap == false) {
          this.appointmentForm.alreadyPatient = { value: false, name: 'Não' };
        }

        this.showWeek = agendaData.show_week;
        this.requiredFields = agendaData.required_fields;

        if(agendaData.professional_photo) {
          this.logo = agendaData.professional_photo;
        }
        else if(agendaData.agenda_logo) {
          this.logo = agendaData.agenda_logo;
        }
        else if(agendaData.logo) {
          this.logo = agendaData.logo;
        }
        this.name = agendaData.name;
        this.description = agendaData.description;
        this.cellphone = agendaData.cellphone;
        this.telephone = agendaData.telephone;
        this.email = agendaData.email;
        // this.healthPlans = agendaData.health_plans;
        this.address = agendaData.address;
        this.agenda = agendaData.agenda;
        this.healthPlanAppointmentFormats = [];
        this.paidAppointmentFormats = [];
        this.agenda.appointment_formats.forEach(appointmentFormat => {
          this.healthPlanAppointmentFormats.push({value: appointmentFormat.id, name: appointmentFormat.format});

          if(appointmentFormat.format !== 'Online') {
            this.paidAppointmentFormats.push({value: appointmentFormat.id, name: appointmentFormat.format + (this.agenda.online_charging && this.agenda.presential_value != null ? (' - R$ ' + this.formatPrice(this.agenda.presential_value)) : '')});
          }
          else if(appointmentFormat.format === 'Online') {
            this.paidAppointmentFormats.push({value: appointmentFormat.id, name: appointmentFormat.format + (this.agenda.online_charging && this.agenda.online_value != null ? (' - R$ ' + this.formatPrice(this.agenda.online_value)) : '')});
          }
        });
        this.healthPlanChanged();
        let days = Object.keys(agendaData.agenda.appointments);
        if(days.length > 0) {
          this.firstDay = days[0];
          this.lastDay = days[days.length - 1];
          this.day = this.firstDay;
          this.schedules = agendaData.agenda.appointments[this.day];

          this.firstWeek = this.moment(this.firstDay).startOf('week');
          this.lastWeek = this.moment(this.lastDay).startOf('week');
          this.week = this.firstWeek;
        }

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Success Get Agenda', res);
      }).catch(err => {
        this.eventBus.$emit('IS_LOADING', false);
        // window.location.href = 'https://www.consultaja.com/';

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Error Get Agenda', err.response);
      });
    },
    // getAppointmentsAvailable() {
    //   this.api.getAgenda(this.$route.params.id, { date: this.date.format('YYYY-MM-DD')}).then(res => {
    //     let agendaData = res.data;
    //
    //     this.agenda = agendaData.agenda;
    //
    //     if(process.env.VUE_APP_SHOW_CONSOLE)
    //       console.log('Success Get Appointments Available', res);
    //   }).catch(err => {
    //     if(process.env.VUE_APP_SHOW_CONSOLE)
    //       console.log('Error Get Appointments Available', err.response);
    //   });
    // },
    healthPlanChanged() {
      let paidAppointment = this.appointmentForm.health_plan != null && this.appointmentForm.health_plan.name == 'Particular';
      this.appointmentFormats = paidAppointment ? this.paidAppointmentFormats : this.healthPlanAppointmentFormats;
      if(this.appointmentForm.appointmentFormat != null) {
        this.appointmentForm.appointmentFormat = this.appointmentFormats.find(d => d.value == this.appointmentForm.appointmentFormat.value);
      }
      this.appointmentFormatChanged();
    },
    appointmentFormatChanged() {
      this.makeAppointmentText = 'Agendar';
      if(!this.agenda.online_charging || this.appointmentForm.appointmentFormat == null) {
        return;
      }
      let paidAppointment = this.appointmentForm.health_plan != null && this.appointmentForm.health_plan.name == 'Particular';
      if(!paidAppointment) {
        return;
      }
      let appointmentFormatIsOnline = this.appointmentForm.appointmentFormat.name.indexOf('Online') === 0,
          value = appointmentFormatIsOnline ? this.agenda.online_value : this.agenda.presential_value;

      if(value != null && (appointmentFormatIsOnline ? this.agenda.charge_to_schedule_online : this.agenda.charge_to_schedule_presential)) {
        this.makeAppointmentText += ' e pagar';
      }
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    increaseDate() {
      if(this.day != this.lastDay) {
        this.dayIndex += 1;
        Object.entries(this.agenda.appointments).forEach((values, index) => {
          if(index == this.dayIndex) {
            this.day = values[0];
            this.schedules = Object.values(values[1]);
          }
        });
      }
    },
    decreaseDate() {
      if(this.day != this.firstDay) {
        this.dayIndex -= 1;
        Object.entries(this.agenda.appointments).forEach((values, index) => {
          if(index == this.dayIndex) {
            this.day = values[0];
            this.schedules = Object.values(values[1]);
          }
        });
      }
    },
    buildAddress(breakLine) {
      if(this.address != null) {
        return this.address.address+', '+this.address.number+(breakLine ? '<br>' : ' - ')+this.address.city+', '+this.address.state;
      }
    },
    selectTime(time) {
      this.appointmentForm.start_datetime = time;
    },
    async goToNextStep() {
      if(!this.canPerformAction)
        return false;

      if(this.actualStep === 1) {
        this.canPerformAction = false;

        this.eventBus.$emit('IS_LOADING', true);

        let appointmentData = {
          start_datetime: this.appointmentForm.start_datetime
        };

        this.api.getAvailableHealthPlans(this.$route.params.id, appointmentData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.actualStep += 1;

          this.healthPlans = res.data.health_plans;

          this.canPerformAction = true;

          if(process.env.VUE_APP_SHOW_CONSOLE)
            console.log('Success Make Appointment', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          let msg = 'Ocorreu um erro ao carregar os detalhes do horário escolhido! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
            case 403: msg = err.response.data.error; break;
          }

          this.$swal('Ops...', msg, 'error');

          this.healthPlans = [];
          this.canPerformAction = true;

          if(process.env.VUE_APP_SHOW_CONSOLE)
            console.log('Error Make Appointment', err.response);
        });
      }
      else {
        this.actualStep += 1;
      }
    },
    async makeAppointment() {
      if(!this.canPerformAction)
        return false;

      this.canPerformAction = false;

      const isValid = await this.$refs.appointmentForm.validate();
      if(!isValid) {
        this.canPerformAction = true;
        return false;
      }

      let appointmentData = {
        start_datetime: this.appointmentForm.start_datetime,
        name: this.appointmentForm.name,
        email: this.appointmentForm.email,
        document: this.appointmentForm.document,
        birthday: this.appointmentForm.birthday,
        cellphone: this.appointmentForm.cellphone,
        alreadyPatient: (this.appointmentForm.alreadyPatient != null)?this.appointmentForm.alreadyPatient.value:null,
        health_plan: (this.appointmentForm.health_plan != null)?this.appointmentForm.health_plan.value:null,
        appointment_format_id: (this.appointmentForm.appointmentFormat != null)?this.appointmentForm.appointmentFormat.value:null
      };

      this.api.makeAppointment(this.$route.params.id, appointmentData).then(res => {
        if(res.status == 201) {
          this.$swal('Uhull \\o/', 'Agendamento realizado com sucesso!', 'success').then(() => {
            window.location.reload();
          });
        }
        else if(res.status == 200) {
          this.$swal('Horário anotado!', 'Agora, você será redirecionado para a página de pagamento para finalizar o seu agendamento.<br><br>⚠️ O agendamento será cancelado automaticamente caso o pagamento não ocorra dentro dos próximos 30 minutos.', 'success').then(() => {
            window.location.href = process.env.VUE_APP_PAYMENT_URL + '/' + this.$route.params.id + '/' + res.data.id;
          });
        }

        this.canPerformAction = true;

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Success Make Appointment', res);
      }).catch(err => {
        let msg = 'Ocorreu um erro ao realizar o agendamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

        switch (err.response.status) {
          case 422: msg = err.response.data.errors.join('\r\n'); break;
          case 403: msg = err.response.data.error; break;
        }

        this.$swal('Ops...', msg, 'error');

        this.canPerformAction = true;

        if(process.env.VUE_APP_SHOW_CONSOLE)
          console.log('Error Make Appointment', err.response);
      });
    }
  }
}
</script>

<style lang="scss">
  .home {
    display: flex;
    overflow: hidden;
    width: 100%;
    min-height: 100vh;

    > .content {
      flex: 1;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
      //background: #F4F4F4;
      display: flex;
      flex-direction: column;
    }

    .info {
      .page-header {
        background: #fff;

        h1 {
          font-size: 24px;
        }
        h4 {
          font-size: 18px;
        }
        p, a {
          font-family: 'sf_pro_displayregular';
          color: #90A6B3;
        }
      }

      .section-title {
        font-size: 24px;
      }
      .selected-time {
        font-size: 18px;
      }

      .box-cj {
        background: #FFFFFF;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        margin-bottom: 30px;

        &.box-collapse {
          margin-bottom: -5px;
          border-radius: 4px 4px 0 0;
        }

        .header {
          padding: 15px 20px;
          border-bottom: 1px solid $athenGray2;

          .title {
            font-size: 16px;
            margin-bottom: 0;
          }
        }
      }
    }

    .font-lighter {
      font-family: 'sf_pro_displaylight';
    }

    .font-2x {
      font-size: 1.5em;
    }

    &.v2 {
      .calendar {
        .header {
          //background-color: $linkWater;
          background-color: #F4F4F4;
          padding: 10px;
          border-radius: 4px 4px 0 0 ;

          .fa-2x {
            font-size: 1.5em;
          }
        }

        .content {
          //background-color: $athenGray1;
          padding: 10px;
          border-radius: 0 0 20px 20px;
        }
      }

      .pointer {
        cursor: pointer;
      }

      .disabled {
        opacity: 0.5;
        cursor: unset;
      }

      .times {
        padding: 0;
        margin: 0;
        list-style-type: none;

        li {
          flex: 1 10%;
          background-color: $tangaroa;
          color: #ffffff;
          margin: 5px;
          padding: 3px 6px;
          text-align: center;
          border-radius: 5px;

          &.selected {
            background-color: $pictionBlue;
          }
        }
      }

      .btn.btn-primary {
        background-color: $tangaroa;
        border-color: $tangaroa;
        color: #ffffff;
      }
    }

    .box-cj {
      background: #FFFFFF;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      margin-bottom: 30px;

      &.box-collapse {
        margin-bottom: -5px;
        border-radius: 4px 4px 0 0;
      }

      .content {
        padding: 15px 20px;
      }
    }

    .credits {
      font-family: 'sf_pro_displayregular';
      font-size: 14px;
      color: $tangaroa;

      a {
        font-family: 'sf_pro_displaysemibold';
        color: $tangaroa;
      }
    }
  }
</style>
